import React from 'react';

function ErrorListItem({ children }) {
    return <li className="error-list-item">{children}</li>;
}

export { ErrorListItem };
